export const FETCH_USER_RECOMMENDATIONS_START = 'FETCH_RECOMMENDATIONS_START';
export const FETCH_USER_RECOMMENDATIONS_SUCCESS = 'FETCH_RECOMMENDATIONS_SUCCESS';
export const FETCH_USER_RECOMMENDATIONS_FAILURE = 'FETCH_RECOMMENDATIONS_FAILURE';
export const SUBMIT_RECOMMENDATION_SUCCESS = 'SUBMIT_RECOMMENDATION_SUCCESS';
export const SHOW_RECOMMENDATIONS_MODAL_PREFILLED = 'SHOW_RECOMMENDATIONS_MODAL_PREFILLED';
export const TOGGLE_SHOW_RECOMMENDATIONS_MODAL = 'TOGGLE_SHOW_RECOMMENDATIONS_MODAL';
